
var stateBuilder = require('./stateBuilder.js');
var actionTypes = require('./actionTypes.js');

const basketVersionAction = require('./actions/basket/basketVersionAction');
const fatalErrorAction = require('./actions/error/fatalErrorAction');
const menuCategoryAction = require('./actions/menuCategory/menuCategoryAction');
const currentComponentAction = require('./actions/component/currentComponentAction');

module.exports.reducer = function (previousState, action)
{
    if (!previousState)
    {
        return stateBuilder.createState();
    }

    if (action.type == actionTypes.basketVersion)
    {
        return basketVersionAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.fatalError)
    {
        return fatalErrorAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.menuCategoryIndex)
    {
        return menuCategoryAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.currentComponent)
    {
        return currentComponentAction.changeState(previousState, action.payload);
    }

    return previousState;
}